import * as React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Image from 'components/Image';
import ContactForm from 'components/Forms/Contact';
import Illustration from 'components/Illustration';

import theme, { remCalc } from 'utils/theme';
import background from 'images/contact/contact-form-background.jpg';
import submarine from 'images/contact/we-all-live-in-a-yellow-submarine.svg';


const GetInTouch = (props) => {
	const [success, setSuccess] = React.useState();

	const contactFormRef = React.useRef(null);

	const sectionStyling = {
		paddingBottom: (props.smallPadding === true ? remCalc(50) : remCalc(463)),
		position: 'relative',
		[theme.breakpoints.down('laptop')]: {
			paddingBottom: (success === true ? remCalc(560) : remCalc(400)),
			paddingTop: remCalc(100),
		}
	};

	const backgroundStyling = {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundImage: `url(${process.env.CDN_DOMAIN||''}${background})`,
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		zIndex: -1,
	}

	const subStyling = {
		position: 'absolute',
		// top: 'auto',
		left: '50%',
		// bottom: remCalc(350),
		transform: 'translateY(-20px) translateX(-120%)',
		[theme.breakpoints.down('laptop')]: {
			// bottom: remCalc(100),
			left: remCalc(0),
			transform: (success === true ? 'translateY(300px)' : 'translateY(600px)'),
		}
	}

    const lightsContainerStyling = {
        position: 'relative',
        '&:before': {
            background: '#112F59',
            content: '""',
            position: 'absolute',
            top: `calc(-300px + 195px)`, // add hills height
            left: 0,
            width: '100%',
            height: '500px',
            zIndex: -1,
        }
    }

    React.useEffect(() => {
    	if (success === true) {
    		contactFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    	}
    }, [success, contactFormRef])

	return (
        <>
		<Box id={props.id} component={'section'} sx={sectionStyling}>
			<Box component={'div'} sx={backgroundStyling}>
			</Box>
			<Container ref={contactFormRef}>
				<Grid container alignContent="center" sx={{
					paddingTop: remCalc(154), paddingBottom: "5rem;",
					[theme.breakpoints.down('sm')]: {
						paddingTop: "2rem",
					}
				}}>
					<Grid size={{ xs: 12, md: 6 }}>
						{ !success &&
							<>
							<Typography component="p" variant="formTitle" sx={{marginBottom: "1rem"}}>Dive in with Z</Typography>
							<Typography component="p" variant="formText" sx={{paddingRight: '60px', marginBottom: "6rem", [theme.breakpoints.down('md')]: {
								marginBottom: "2.75rem"
							} }}>
								Zehnder is always on the lookout for great collaborators. From clients aspiring to drive sustainable growth to fresh talent hoping to join the team, we welcome you to drop us a line. We’ll be in touch!
							</Typography>
							<Box component={'div'} sx={subStyling}>
								<Image src={submarine} width={"600px"} height={"432px"} style={{maxWidth: '100%'}} />
							</Box>
							</>
						}
						{ success &&
							<>
							<Box component={'div'} sx={subStyling}>
								<Illustration illustration="mermaid" />
							</Box>
							</>
						}
					</Grid>
					<Grid className="contact_form__grid" container alignContent="center" justifyContent="center" alignItems="center" direction={"column"} gap={0} size={{ xs: 12, md: 6 }}>
						<Box component={'div'} className="contact_form__wrapper">
							<ContactForm onSuccess={() => setSuccess(true)} />
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Box>
        {!props?.hideHills && <Box sx={lightsContainerStyling} />}
        </>
	)
}

export default GetInTouch;